var map = {
	"./decidim/challenges/decidim_challenges_icon.svg": 5945,
	"./decidim/sdgs/ods-01.svg": 2442,
	"./decidim/sdgs/ods-02.svg": 7257,
	"./decidim/sdgs/ods-03.svg": 1896,
	"./decidim/sdgs/ods-04.svg": 6823,
	"./decidim/sdgs/ods-05.svg": 7846,
	"./decidim/sdgs/ods-06.svg": 9621,
	"./decidim/sdgs/ods-07.svg": 2372,
	"./decidim/sdgs/ods-08.svg": 5651,
	"./decidim/sdgs/ods-09.svg": 5893,
	"./decidim/sdgs/ods-10.svg": 8984,
	"./decidim/sdgs/ods-11.svg": 1353,
	"./decidim/sdgs/ods-12.svg": 2058,
	"./decidim/sdgs/ods-13.svg": 875,
	"./decidim/sdgs/ods-14.svg": 3172,
	"./decidim/sdgs/ods-15.svg": 1157,
	"./decidim/sdgs/ods-16.svg": 4518,
	"./decidim/sdgs/ods-17.svg": 7735,
	"./decidim/sdgs/sdg-wheel.png": 4639,
	"./decidim/sdgs/un_emblem_square.png": 3145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7970;